<h2 mat-dialog-title>Liberação necessária</h2>

<mat-dialog-content>
    <p class="descricao-modal">
        Este documento tem {{ data.bloqueios.length === 1 ? 'um bloqueio' : data.bloqueios.length + ' bloqueios' }}
        que só um supervisor pode liberar. A liberação fica registrada no histórico do documento, em nome
        de quem autorizou.
    </p>

    <ul class="vld-lista">
        @for (bloqueio of data.bloqueios; track bloqueio.idVendaTipoBloqueio) {
        <li class="vld-bloqueio">
            <mat-icon class="vld-icone">lock</mat-icon>
            <div class="vld-texto">
                <strong>{{ bloqueio.titulo }}</strong>
                <span>{{ bloqueio.descricao }}</span>
            </div>
        </li>
        }
    </ul>

    <p class="vld-subtitulo">Credencial do supervisor</p>

    <div class="row">
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>E-mail</mat-label>
                <input matInput type="email" autocomplete="off" name="vldEmail" [(ngModel)]="email">
            </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Senha</mat-label>
                <input matInput [type]="mostrarSenha ? 'text' : 'password'" autocomplete="new-password" name="vldSenha"
                    [(ngModel)]="senha" (keydown.enter)="liberar()">
                <button mat-icon-button matSuffix type="button" class="icon-mat-symbols-btn"
                    (click)="mostrarSenha = !mostrarSenha" [attr.aria-label]="mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'">
                    <mat-icon>{{ mostrarSenha ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>

    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Observação (opcional)</mat-label>
        <textarea matInput rows="2" maxlength="2000" name="vldObservacao" [(ngModel)]="observacao"></textarea>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="!podeLiberar" (click)="liberar()">Liberar agora</button>
</mat-dialog-actions>
